import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import { PageHeader } from '../../components/ui/PageHeader';
import { getPageSubtitle } from '../../constants/pageSubtitles';
import { superAdminAPI } from '../../services/api';
import { useLocale } from '../../contexts/LocaleContext';
import { SuperAdminDataTable, apiErrorMessage, statusChip } from '../../components/superadmin/SuperAdminDataTable';

const LOGIN_STATUS_OPTIONS = [
  { label: 'Success', value: 'true' },
  { label: 'Failed', value: 'false' },
];

export const SecurityPage: React.FC = () => {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { formatDate } = useLocale();

  useEffect(() => {
    superAdminAPI.getLoginLogs()
      .then((r) => setLogs(r.data))
      .catch((err) => setError(apiErrorMessage(err, 'Failed to load login logs')))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box>
      <PageHeader title="Security & Login Logs" subtitle={getPageSubtitle('security')}
        icon={<SecurityIcon />}
 />
      <SuperAdminDataTable
        rows={logs}
        loading={loading}
        error={error}
        exportFileName="super-admin-security-logs"
        exportSheetName="Login Logs"
        searchPlaceholder="Search email, IP..."
        statusOptions={[
          { label: 'All', value: 'all' },
          { label: 'Success', value: 'true' },
          { label: 'Failed', value: 'false' },
        ]}
        getStatus={(log) => String(log.success)}
        columns={[
          {
            id: 'email',
            header: 'Email',
            searchValue: (l) => l.email,
            exportValue: (l) => l.email,
            render: (l) => <strong>{l.email}</strong>,
          },
          {
            id: 'role',
            header: 'Role',
            searchValue: (l) => l.roleType,
            exportValue: (l) => l.roleType,
            render: (l) => l.roleType?.replace('_', ' ') || '—',
          },
          {
            id: 'ip',
            header: 'IP',
            searchValue: (l) => l.ipAddress,
            exportValue: (l) => l.ipAddress,
            render: (l) => l.ipAddress,
          },
          {
            id: 'status',
            header: 'Status',
            exportValue: (l) => l.success ? 'Success' : 'Failed',
            filterType: 'select',
            filterOptions: LOGIN_STATUS_OPTIONS,
            filterValue: (l) => String(l.success),
            render: (l) => statusChip(l.success ? 'active' : 'inactive'),
          },
          {
            id: 'time',
            header: 'Time',
            searchValue: (l) => l.createdAt ? String(l.createdAt) : '',
            exportValue: (l) => l.createdAt,
            render: (l) => formatDate(l.createdAt, { hour: '2-digit', minute: '2-digit' }),
          },
        ]}
      />
    </Box>
  );
};
